import React from "react";
import { Helmet } from "react-helmet";

const SEO = () => {
  return (
    <Helmet>
      {/* Open Graph Metadata */}
      <meta property="og:title" content="commceed | Innovation in Motion, Solutions in Action" />
      <meta
        property="og:description"
        content="commceed delivers innovative networking solutions, ensuring seamless connectivity and future-ready infrastructure. We transform ideas into reality with precision and expertise."
      />
      <meta property="og:url" content="https://commceed.com" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://commceed.com/logo512.png" />

      {/* Twitter Metadata */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="commceed | Innovation in Motion, Solutions in Action" />
      <meta
        name="twitter:description"
        content="commceed delivers innovative networking solutions, ensuring seamless connectivity and future-ready infrastructure. We transform ideas into reality with precision and expertise."
      />
      <meta name="twitter:image" content="https://commceed.com/logo512.png" />

      {/* Structured Data for Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "commceed",
          "url": "https://commceed.com",
          "logo": "https://commceed.com/logo512.png",
          "description":
            "At commceed, we provide global supply chain solutions, transforming ideas into innovative products that power networks and elevate infrastructures across the globe."
        })}
      </script>
      <meta name="keywords" content="commceed, innovative networking solutions, future-ready infrastructure, supply chain solutions, technology solutions" />

      <title>commceed</title>
    </Helmet>
  );
};

export default SEO;
